import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import MarkdownNavbar from 'markdown-navbar';
import { useOutletContext } from 'react-router-dom';
import rehypeRaw from 'rehype-raw'; // 允许md文件中使用html代码
import remarkGfm from 'remark-gfm'; // 划线、表、任务列表和直接url等的语法扩展
import 'github-markdown-css/github-markdown-light.css';
import 'markdown-navbar/dist/navbar.css';
import './github-markdown.less';
// import './markdown-here.less';

const Markdown = ({ url }) => {
  const [mdContent, setMdContent] = useState('');
  const { isMobile } = useOutletContext();
  useEffect(() => {
    // fetch(url)
    //   .then((res) => res.text())
    //   .then((text) => setMdContent(text));
    const md = require(`@/articles/${url}`).default;
    setMdContent(md);
  }, []);
  console.log(isMobile);
  return (
    <div style={{ display: 'flex', marginTop: isMobile ? '68px' : 0}}>
      {!isMobile && (
        <div className='navbar' style={{ flex: '0 0 18%', order: -1 }}>
          <MarkdownNavbar
            source={mdContent}
            headingTopOffset={80}
            ordered={false}
          />
        </div>
      )}
      <div style={{ flex: '1', padding: '0 15%' }}>
        <ReactMarkdown
          className='markdown-body'
          remarkPlugins={[remarkGfm]}
          rehypePlugins={[rehypeRaw]}
        >
          {mdContent}
        </ReactMarkdown>
      </div>
    </div>
  );
};

export default Markdown;
